import { render, staticRenderFns } from "./ToolbarIndicePreco.vue?vue&type=template&id=99618930&scoped=true"
import script from "./ToolbarIndicePreco.vue?vue&type=script&lang=js"
export * from "./ToolbarIndicePreco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99618930",
  null
  
)

export default component.exports